/*
 * Copyright© Celligence International, LLC - 2023
 * 
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 * 
 */


import React from 'react'
import { Modal, Button } from 'react-bootstrap'


const modal = (props) => {

    return (
        <Modal show={props.show} size={props.size} onHide={props.onHide} {...props}>
            <Modal.Header closeButton >
                <Modal.Title>{props.title ? props.title : null}</Modal.Title>
            </Modal.Header>
            {props.children}
            <Modal.Footer>
                {props.footer}
                <Button variant="primary" onClick={props.onHide} style={{ display: 'none' }}>
                    Close
                </Button>
            </Modal.Footer>

        </Modal>
    )
}
export default modal